import { render, staticRenderFns } from "./YanYana.vue?vue&type=template&id=2321ed5c&scoped=true"
import script from "./YanYana.vue?vue&type=script&lang=js"
export * from "./YanYana.vue?vue&type=script&lang=js"
import style0 from "./YanYana.vue?vue&type=style&index=0&id=2321ed5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2321ed5c",
  null
  
)

export default component.exports